/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} User_Role_Add_TitleInputs */

const vi_user_role_add_title = /** @type {(inputs: User_Role_Add_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thêm vai trò ${i?.name}`)
};

/**

* @param {User_Role_Add_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_role_add_title = /** @type {((inputs: User_Role_Add_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Role_Add_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_role_add_title(inputs)
});